import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        window.gtag('config', 'AW-16724784395', {
            page_path: location.pathname,
        });
    }, [location]);

    return null;
}